import { ElementState } from "@creatomate/preview";

const thresholdCheck = (magnetThreshold: number): {
  elementsStartValidation: (elmnt: ElementState, time: number) => boolean;
  elementsEndValidation: (elmnt: ElementState, time: number) => boolean;
} => {
  const isWithinThreshold = (value: number, target: number) => (
    value > target - magnetThreshold && value < target + magnetThreshold
  );

  const elementsStartValidation = (elmnt: ElementState, time: number) => (
    isWithinThreshold(elmnt.localTime, time)
  );
  const elementsEndValidation = (elmnt: ElementState, time: number) => (
    isWithinThreshold(elmnt.localTime + elmnt.duration, time)
  );

  return { elementsStartValidation, elementsEndValidation };
};

export default thresholdCheck;
